module.exports = __webpack_public_path__ + "assets/img/hero-image.211dcc46.png";